<!-- VSI Assist on its own page (opened from the panel's "Open in new tab" button) -->
<div class="app-bg min-vh-100" data-bs-theme="dark">
    <BolideAssistant standalone :is_open="true" @close-assistant="close_assistant" />
</div>
